import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ROOM_EDIT, smokingPolicies } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  allCategoriesSelector,
  allRoomsSelector,
  allRoomTypesSelector,
} from '../../../../property/propertySlice';
import './Room-View.scss';

const RoomView = (props) => {
  const { room, onViewToggle, toggleDrawer, hotelId, permissions } = props;
  const [selectedRoom, setSelectedRoom] = useState(room);
  const originalRoomTypes = useSelector(allRoomTypesSelector);
  const originalCateogires = useSelector(allCategoriesSelector);
  const originalRooms = useSelector(allRoomsSelector);

  useEffect(() => {
    // retreiving selected room details from api
    const roomObj = {
      ...originalRooms.find((tempRoom) => tempRoom.id === room.id),
    };
    roomObj['category'] = originalCateogires.find((c) => c.id === roomObj.categoryId);
    roomObj['roomType'] = originalRoomTypes.find((r) => r.id === roomObj.roomTypeId);
    setSelectedRoom(roomObj);
  }, [hotelId, originalRooms]);

  const onClickEdit = (event) => {
    toggleDrawer(ROOM_EDIT, true, selectedRoom);
  };

  const renderScreen = () => {
    return (
      <div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12 mb-4'>
            <span className='page-title-secondary'>Details</span>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Room Number</div>
            <div className='details-value'>{selectedRoom.number}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Room Type</div>
            <div className='details-value'>{selectedRoom.roomType?.name}</div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>Room Type Code</div>
            <div className='details-value'>{selectedRoom.roomType?.code}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Category</div>
            <div className='details-value'>
              {selectedRoom.category?.name ? selectedRoom.category?.name : '---'}
            </div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>Category Code</div>
            <div className='details-value'>
              {selectedRoom.category?.code ? selectedRoom.category?.code : '---'}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12'>
            <div className='details-label'>Description</div>
            <div className='details-value preview-breaks'>{selectedRoom.description}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Room Area</div>
            <div className='details-value'>
              {selectedRoom.area} {selectedRoom.areaSizeUnit}
            </div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Room View</div>
            <div className='details-value'>
              {selectedRoom.roomView ? selectedRoom.roomView : '---'}
            </div>
          </div>
          <div className='col-md-4'>
            <div className='details-label'>Smoking Policy</div>
            <div className='details-value'>
              {selectedRoom.isSmokingAllowed ? smokingPolicies[0].name : smokingPolicies[1].name}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Maximum Occupancy</div>
            <div className='details-value'>{selectedRoom.maxOccupancy}</div>
          </div>
        </div>
        {/* temporarily disabled */}
        {/* <div className="row mx-4 mt-4">
          <div className="col-md-4">
            <div className="details-label">Housekeeping (Day Section)</div>
            <div className="details-value">
              {selectedRoom.houseKeepingDaySection ? selectedRoom.houseKeepingDaySection : "---"}
            </div>
          </div>
          <div className="col-md-8">
            <div className="details-label">Housekeeping (Evening Section)</div>
            <div className="details-value">
              {selectedRoom.houseKeepingEveningSection ? selectedRoom.houseKeepingEveningSection : "---"}
            </div>
          </div>
        </div> */}
      </div>
    );
  };

  return (
    <>
      {selectedRoom && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          title={'Room no - ' + selectedRoom.number}
          createdUserId={selectedRoom.createdBy}
          isEditable={
            permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
        />
      )}
    </>
  );
};

export default RoomView;
